import { SxProps } from '@mui/material';
import { grayDefault, grey10, white } from 'app/components/ThemeProvider/colors';
import { getTheme } from 'app/components/ThemeProvider/theme';

const theme = getTheme('light');
export const bg: SxProps = {
  background: grey10,
  width: '74%',
};

export const addBannerBox: SxProps = {
  display: 'flex',
  background: 'white',
  justifyContent: 'space-between',
  position: 'relative',
  borderRadius: '8px',
  boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
};

export const closeButton: SxProps = {
  position: 'absolute',
  right: '-15px',
  top: '-15px',
  background: 'white',
  width: '30px',
  height: '30px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
};

export const bannerDesc: SxProps = {
  p: '32px 0 28px 40px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};

export const bannerText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '24px',
  fontWeight: '600',
  lineHeight: '32px',
  width: '245px',
};

export const bannerBtn: SxProps = {
  fontSize: '13px',
  width: 'fit-content',
  fontWeight: '600',
};

export const cardBox = (expand: boolean, boxName?: string) => ({
  background: white,
  p: '28px',
  borderRadius: '8px',
  width: '100%',
  boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
  [theme.breakpoints.down(1400)]: {
    pl: expand ? '24px' : '28px',
    pr: expand ? '24px' : '28px',
  },
  [theme.breakpoints.down('lg')]: {
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    minWidth: '280px',
    overflowX: 'auto',
  },
});

export const lastOperationBox: SxProps = {
  background: white,
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  width: '100%',
  boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
  pt: '28px',
  display: 'flex',
  flexDirection: 'column',
  gap: '28px',
  minHeight: '604px',

  [theme.breakpoints.down('md')]: {
    width: '100%',
    flexDirection: 'column',
  },
};

export const mainBoxes: SxProps = {
  display: 'flex',
  gap: '28px',
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
  },
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
  },
};

export const accountNone: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '16px',
  p: '0 24px',
  textAlign: 'center',
  height: '100%',
};
export const searchNone: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: grayDefault,
  p: '8px',
  borderRadius: '8px',
};
